// extracted by mini-css-extract-plugin
export default {"divCard":"CountryCard_divCard__ZYI-F","txtName":"CountryCard_txtName__AA9S0","txtContinent":"CountryCard_txtContinent__jpBA5"};